import React from 'react';
import {
  Dialog as MuiDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Box,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import Button from '../ui/button';

const Dialog = ({
  open,
  onClose,
  title,
  description,
  children,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  hideCancel = false,
  hideConfirm = false,
  confirmColor = '#FDA041',
  maxWidth="xs",
  // showIcon = false,
  // icon,
}) => {
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          // width: '400px',
          boxShadow: 'none',
          padding: '24px',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'column',
          gap: 2.5,
          maxHeight: '600px',
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'var(--gray-500)',
        }}
      >
        <Close />
      </IconButton>

      <DialogTitle sx={{ display: 'flex', padding: '0px', gap: 1, flexDirection: 'column'}}>
        {/* {showIcon && icon && (
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            {icon}
          </Box>
        )} */}
        <Typography variant="h4" fontWeight="600">
          {title}
        </Typography>
        {description && <Typography variant="body1" color="var(--gray-700)">{description}</Typography>}

      </DialogTitle>

      {children && <DialogContent
        sx={{ display: 'flex', padding: '0px', flexDirection: 'column', gap: '1rem' }}
      >
        {/* {description && <Typography variant="body1" color="var(--gray-700)">{description}</Typography>} */}
        {children}
      </DialogContent>}

      {/* Buttons */}
       {(!hideCancel || !hideConfirm) && (
        <DialogActions
          sx={{
            justifyContent: hideCancel ? 'center' : 'flex-end',
            width: '100%',
            padding: '0px',
          }}
        >
          {!hideCancel && (
            <Button variant="outlined" onClick={onCancel || onClose}>
              {cancelText}
            </Button>
          )}
          {!hideConfirm && (
            <Button
              variant="contained"
              bgColor={confirmColor}
              onClick={onConfirm}
              fullWidth={hideCancel ? true : false}
            >
              {confirmText}
            </Button>
          )}
        </DialogActions>
      )}
    </MuiDialog>
  );
};

export default Dialog;